import React from 'react';
import withTranslation from 'hoc/withTranslation';

const SessionsView = ({ translations: { sessions } }) => (
  <h1 data-testid="sessions-placeholder-heading">{sessions.title}</h1>
);

export default withTranslation(SessionsView);